import { render, staticRenderFns } from "./JudgingShortcut.vue?vue&type=template&id=96571998&"
import script from "./JudgingShortcut.vue?vue&type=script&lang=js&"
export * from "./JudgingShortcut.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports